export default "__VITE_ASSET__a3ead8f4__"